import { useState, useEffect } from 'react';
import axios from 'axios';

const LoadDataHospital = () => {

    const [dataClinic, setDataClinic] = useState(null);

    const getDataClinic = () => {
        axios({
            method: 'get',
            url: `https://script.google.com/macros/s/AKfycbwAMX25yxw_aksB3VkTlN_pbn4_oj0WD861BZtnz810kMql9IyXieflQ36Ofm58CPjnoA/exec?id=1`,
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then((res) => {

                if (res.data && res.data.results) {
                    setDataClinic(res.data.results);
                }

            })
            .catch((error) => {

                console.error('Error fetching data:', error.message);

            })
    };

    useEffect(() => {
        getDataClinic();
    }, []); // Run on component mount

    // Return loading, error, or data states
    return dataClinic;
};

export default LoadDataHospital;
